import React, { useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Snackbar,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Divider
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function BoletoLayout() {
    // Mock estruturado com base nos dados e no template blade fornecido
    const invoiceData = {
        id: "9976ff55-d230-4fa3-a9ee-6ec03f8779d4",
        amount: 333.32,
        due_date: "2023-06-10T07:00:00.000000Z",
        created_at: "2023-06-21T16:08:10.000000Z",
        reference: "2323",
        status: {
            id: 3,
            name: "Cancelada",
            extended_name: "Fatura Cancelada"
        },
        costumer: {
            fullname: "ADRIANA MAGALHÃES MONACO",
            tax_identifier: "858.753.965-55",
            documento: "85875396555"
        },
        bsAccount: {
            fantasy_name: "Sage Bds",
            highlight_name: "Sage Bds",
            identifier: "41.263.652/0001-04"
        },
        boleto: {
            nossonumero: "80144184141",
            barcode: "21898938800000333320010008507597801441841418",
            digitable_line: "21890010070850759780814418414182893880000033332",
            billing_business_boleto_vendor_id: 1,
            billing_business_invoice_boleto_id: "cUsCwKm27v",
            messages_array: {
                line1: "Não receber este pagamento via cheque",
                line2: "",
                line3: "",
                line4: ""
            }
        },
        pix: {
            qrcode: "00020126580014br.gov.bcb.pix..."
        }
    };

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");

    const handleCopy = (text, label) => {
        navigator.clipboard.writeText(text);
        setSnackbarMessage(`${label} copiado com sucesso!`);
        setOpenSnackbar(true);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("pt-BR");
    };

    const formatCurrency = (value) => {
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL"
        }).format(value);
    };

    return (
        <Box sx={{ maxWidth: 1000, margin: "auto", padding: 3, position: "relative" }}>

            {/* Marca d'água de Status (Posicionada exatamente como no template .blade.php) */}
            <Box
                sx={{
                    position: "absolute",
                    top: "40%",
                    left: "50%",
                    transform: "translate(-50%, -50%) rotate(302deg)",
                    zIndex: 5,
                    opacity: 0.5,
                    pointerEvents: "none",
                    textAlign: "center",
                    width: "100%"
                }}
            >
                <Typography
                    sx={{
                        fontWeight: "bold",
                        color: "#000000",
                        fontSize: "5rem",
                        backgroundColor: "#d8d3d3",
                        padding: "10px"
                    }}
                >
                    {invoiceData.status.extended_name}
                </Typography>
            </Box>

            <Card sx={{ boxShadow: 3, padding: 4, position: "relative", backgroundColor: "#fff" }}>
                <CardContent>

                    {/* TOPO: Cabeçalho do Boleto com Pix e Resumo */}
                    <Grid container spacing={3} alignItems="center" sx={{ mb: 4 }}>
                        <Grid item xs={12} md={7}>
                            <Box textAlign="center" mb={2}>
                                <Typography variant="h4" fontWeight="bold">
                                    {invoiceData.bsAccount.fantasy_name}
                                </Typography>
                            </Box>
                            <Box textAlign="center" mb={2}>
                                <Typography variant="h6" color="primary" fontWeight="bold">
                                    PAGUE USANDO PIX - <span style={{ fontSize: "0.8rem" }}>COMPENSAÇÃO IMEDIATA</span>
                                </Typography>
                            </Box>
                            <Typography variant="body2" color="text.secondary" align="center">
                                Para pagar, basta pegar o smartphone, acessar o aplicativo onde está o seu PIX ativo.
                            </Typography>
                            <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 2 }}>
                                Acione a opção de pagamento e aponte a câmera do aparelho para realizar a transação.
                            </Typography>

                            {/* PIX Copia e Cola */}
                            <Box sx={{ mt: 2, backgroundColor: "#f8f9fa", p: 2, borderRadius: 1 }}>
                                <Typography variant="subtitle2" fontWeight="bold" color="text.secondary" gutterBottom>
                                    PIX copia e cola
                                </Typography>
                                <textarea
                                    readOnly
                                    value={invoiceData.pix.qrcode}
                                    onClick={(e) => {
                                        e.target.select();
                                        handleCopy(invoiceData.pix.qrcode, "Código Pix");
                                    }}
                                    rows={2}
                                    style={{ width: "100%", fontSize: "12px", padding: "6px", fontFamily: "monospace" }}
                                />
                                <Button
                                    id="button_copyclipboard"
                                    variant="contained"
                                    size="small"
                                    sx={{ mt: 1 }}
                                    onClick={() => handleCopy(invoiceData.pix.qrcode, "Código Pix")}
                                >
                                    Copiar Código Pix
                                </Button>
                            </Box>
                        </Grid>

                        {/* Coluna da Direita (Dados rápidos e QR Code Pix) */}
                        <Grid item xs={12} md={5} sx={{ textAlign: "center", borderLeft: { md: "1px dashed #dfdfdf" } }}>
                            <Typography variant="body2" fontWeight="bold" noWrap>
                                {invoiceData.costumer.fullname} - CPF/CNPJ {invoiceData.costumer.tax_identifier}
                            </Typography>
                            <Typography variant="body1" sx={{ mt: 1 }}>
                                VALOR A PAGAR: <strong>{formatCurrency(invoiceData.amount)}</strong>
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                VENCIMENTO: <strong>{formatDate(invoiceData.due_date)}</strong>
                            </Typography>
                            <Box component="img" src={`https://qrcode.worker.cachebank.com.br/?data=${invoiceData.pix.qrcode}`} alt="QR Code Pix" width={150} />
                            <Typography variant="caption" display="block" fontWeight="bold" sx={{ mt: 1 }}>
                                ESCANEIE O QRCODE P/ PAGAR!
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider sx={{ my: 3 }} />

                    {/* PARTE SUPERIOR DO BOLETO (Recibo do Pagador) */}
                    <Box sx={{ fontSize: "11px", border: "1px solid #dfdfdf", p: 1, mb: 3 }}>
                        <Grid container spacing={1}>
                            <Grid item xs={6} md={3} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Nome do Beneficiário</Typography>
                                <Typography variant="body2">Cachê Digital a serviço de: <br /><b>{invoiceData.bsAccount.highlight_name}</b></Typography>
                            </Grid>
                            <Grid item xs={6} md={3} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">CNPJ</Typography>
                                <Typography variant="body2">{invoiceData.bsAccount.identifier}</Typography>
                            </Grid>
                            <Grid item xs={6} md={3} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Agência / Conta</Typography>
                                <Typography variant="body2">0001 / 850759-7</Typography>
                            </Grid>
                            <Grid item xs={6} md={3} sx={{ border: "1px solid #dfdfdf", p: 1, backgroundColor: "#f8f9fa" }}>
                                <Typography variant="caption" fontWeight="bold">Vencimento</Typography>
                                <Typography variant="body2" align="right">{formatDate(invoiceData.due_date)}</Typography>
                            </Grid>

                            <Grid item xs={8} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Pagador</Typography>
                                <Typography variant="body2">{invoiceData.costumer.fullname} - CPF/CNPJ {invoiceData.costumer.tax_identifier}</Typography>
                            </Grid>
                            <Grid item xs={4} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Nosso número</Typography>
                                <Typography variant="body2">{invoiceData.boleto.nossonumero}</Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ border: "1px solid #dfdfdf", p: 1, backgroundColor: "#f8f9fa" }}>
                                <Typography variant="caption" fontWeight="bold">Valor do Documento</Typography>
                                <Typography variant="body1" align="right" fontWeight="bold">{formatCurrency(invoiceData.amount)}</Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* LINHA DE CORTE */}
                    <Box sx={{ borderBottom: "2px dashed #dfdfdf", my: 3 }} />

                    {/* PARTE INFERIOR DO BOLETO (Ficha de Compensação) */}
                    <Box sx={{ fontSize: "11px", border: "1px solid #dfdfdf", p: 1 }}>

                        {/* Cabeçalho Banco */}
                        <Grid container alignItems="center" sx={{ mb: 2, borderBottom: "1px solid #dfdfdf", pb: 1 }}>
                            <Grid item xs={3}>
                                <Box component="img" src="https://i.imgur.com/uiUk79A.png" alt="Banco" sx={{ width: 70 }} />
                            </Grid>
                            <Grid item xs={2} sx={{ borderLeft: "1px solid #dfdfdf", pl: 1 }}>
                                <Typography variant="h6" fontWeight="bold">218</Typography>
                            </Grid>
                            <Grid item xs={7} textAlign="right">
                                <Typography variant="subtitle1" fontWeight="bold" sx={{ fontFamily: "monospace" }}>
                                    {invoiceData.boleto.digitable_line}
                                </Typography>
                            </Grid>
                        </Grid>

                        {/* Blocos de Dados do Boleto */}
                        <Grid container spacing={0}>
                            <Grid item xs={9} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Local de Pagamento</Typography>
                                <Typography variant="body2">Pagável em qualquer Banco, Lotérica, Internet Banking e outros</Typography>
                            </Grid>
                            <Grid item xs={3} sx={{ border: "1px solid #dfdfdf", p: 1, backgroundColor: "#f8f9fa" }}>
                                <Typography variant="caption" fontWeight="bold">Vencimento</Typography>
                                <Typography variant="body2" align="right">{formatDate(invoiceData.due_date)}</Typography>
                            </Grid>

                            <Grid item xs={9} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Nome do Beneficiário</Typography>
                                <Typography variant="body2">Cachê Digital a serviço de: <b>{invoiceData.bsAccount.highlight_name}</b> - CPF/CNPJ: {invoiceData.bsAccount.identifier}</Typography>
                            </Grid>
                            <Grid item xs={3} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Agência/Código cedente</Typography>
                                <Typography variant="body2" align="right">0001 / 850759-7</Typography>
                            </Grid>

                            <Grid item xs={2} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Data do Documento</Typography>
                                <Typography variant="body2">{formatDate(invoiceData.created_at)}</Typography>
                            </Grid>
                            <Grid item xs={2} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Nº do Documento</Typography>
                                <Typography variant="body2">{invoiceData.boleto.billing_business_invoice_boleto_id}</Typography>
                            </Grid>
                            <Grid item xs={2} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Espécie Doc.</Typography>
                                <Typography variant="body2">Outro</Typography>
                            </Grid>
                            <Grid item xs={1} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Aceite</Typography>
                                <Typography variant="body2">N</Typography>
                            </Grid>
                            <Grid item xs={2} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Processamento</Typography>
                                <Typography variant="body2">{formatDate(invoiceData.created_at)}</Typography>
                            </Grid>
                            <Grid item xs={3} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Nosso número</Typography>
                                <Typography variant="body2" align="right">{invoiceData.boleto.nossonumero}</Typography>
                            </Grid>

                            <Grid item xs={2} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Uso do Banco</Typography>
                            </Grid>
                            <Grid item xs={2} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Carteira</Typography>
                                <Typography variant="body2">Cbr Simples</Typography>
                            </Grid>
                            <Grid item xs={2} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Espécie Moeda</Typography>
                                <Typography variant="body2">REAL</Typography>
                            </Grid>
                            <Grid item xs={2} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Quantidade</Typography>
                            </Grid>
                            <Grid item xs={1} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Valor</Typography>
                            </Grid>
                            <Grid item xs={3} sx={{ border: "1px solid #dfdfdf", p: 1, backgroundColor: "#f8f9fa" }}>
                                <Typography variant="caption" fontWeight="bold">(=) Valor do Documento</Typography>
                                <Typography variant="body2" align="right" fontWeight="bold">{formatCurrency(invoiceData.amount)}</Typography>
                            </Grid>

                            {/* Instruções e Valores Adicionais */}
                            <Grid item xs={9} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Instruções</Typography>
                                <Typography variant="body2">{invoiceData.boleto.messages_array.line1}</Typography>
                            </Grid>
                            <Grid item xs={3} sx={{ border: "1px solid #dfdfdf", p: 0 }}>
                                <Box sx={{ borderBottom: "1px solid #dfdfdf", p: 0.5 }}>
                                    <Typography variant="caption" fontWeight="bold">(-) Descontos / Abatimentos</Typography>
                                </Box>
                                <Box sx={{ borderBottom: "1px solid #dfdfdf", p: 0.5 }}>
                                    <Typography variant="caption" fontWeight="bold">(-) Outras Deduções</Typography>
                                </Box>
                                <Box sx={{ borderBottom: "1px solid #dfdfdf", p: 0.5 }}>
                                    <Typography variant="caption" fontWeight="bold">(+) Mora / Multa</Typography>
                                </Box>
                                <Box sx={{ borderBottom: "1px solid #dfdfdf", p: 0.5 }}>
                                    <Typography variant="caption" fontWeight="bold">(+) Outros Acréscimos</Typography>
                                </Box>
                                <Box sx={{ p: 0.5 }}>
                                    <Typography variant="caption" fontWeight="bold">(=) Valor Cobrado</Typography>
                                </Box>
                            </Grid>

                            {/* Pagador */}
                            <Grid item xs={9} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Pagador</Typography>
                                <Typography variant="body2">{invoiceData.costumer.fullname} - CPF/CNPJ: {invoiceData.costumer.tax_identifier}</Typography>
                            </Grid>
                            <Grid item xs={3} sx={{ border: "1px solid #dfdfdf", p: 1 }}>
                                <Typography variant="caption" fontWeight="bold">Código de Baixa</Typography>
                            </Grid>
                        </Grid>

                        {/* Código de Barras Imagem e Ficha de Compensação final */}
                        <Grid container alignItems="center" sx={{ mt: 2 }}>
                            <Grid item xs={8}>
                                <Box
                                    component="img"
                                    src={`https://fatura.cachebank.com.br/api/v3/show/barcode/${invoiceData.boleto.barcode}`}
                                    alt="Código de Barras"
                                    sx={{ height: 50, width: "100%", objectFit: "contain" }}
                                />
                            </Grid>
                            <Grid item xs={4} textAlign="right">
                                <Typography variant="subtitle1" fontWeight="bold">
                                    FICHA DE COMPENSAÇÃO
                                </Typography>
                            </Grid>
                        </Grid>

                    </Box>
                </CardContent>
            </Card>

            {/* Snackbar de Feedback de Cópia */}
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: "100%" }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
}